import React from 'react';
import { Form, Col, Row, Spinner, Dropdown } from 'react-bootstrap';
import { MultiSelect } from "react-multi-select-component";
import BootstrapTable from 'react-bootstrap-table-next';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

class ManageWallet extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);
        console.log(props);
        this.state = {
            user: userExists ? props.location.state.user : {},
            invoices: [],
            totalAmount: 0,
            accountID: props.location.state.account.accountID,
            forceRefreshVar: 0,
            loading: false,
            cards: [],
            selectedCard:[],
            embedURLEdit: '',
            embedURLNew: '',
            embedURL: ''
        };

        this.selectCard = this.selectCard.bind(this);
        this.hideSpinner = this.hideSpinner.bind(this);
        this.addNew = this.addNew.bind(this);
    }

    componentDidMount() {
        console.log(this.state);
        axios.get(`${Constants.apiURL}/api/Payment/GetWallet`, {
            params: {
                username: this.state.user.username,
                accountID: this.state.accountID
            }
        }).then(response => {
            if (response.data) {
                let cards = response.data.map(function (card) {
                    return {
                        label: card.CardName + ' ending in ' + card.Card,
                        value: card.Id,
                        token: card.Token
                    };
                });

                this.setState(() => ({
                    cards: cards
                }));


                axios.get(`${Constants.apiURL}/api/Payment/GetWalletURLs`).then(response => {
                    if (response.data) {
                        this.setState(() => ({
                            embedURLEdit: response.data.edit,
                            embedURLNew: response.data.new
                        }));
                    }
                }).catch((response) => {
                    // ? Show to user that request is failed
                    this.setState({ errors: [response] })
                    this.setState({ loading: false });
                    console.log('request failed', response)
                });


            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    addNew(event) {
        console.log(event);
        axios.get(`${Constants.apiURL}/api/Payment/GetToken`).then(response => {
            if (response.data) {
                let url = this.state.embedURLNew.replace('{@CUSTOMER_NUMBER}', this.state.accountID).replace('{@TENDER}', event).replace('{@TOKEN}', response.data);
                console.log(url);
                this.setState({
                    embedURL: url,
                    selectedCard: [],
                    loading: true
                });
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    selectCard(event) {
        if (event.length > 0) {
            let card = event[event.length - 1];
            axios.get(`${Constants.apiURL}/api/Payment/GetToken`).then(response => {
                if (response.data) {
                    let x = event[event.length - 1];
                    x.token = response.data;
                    let url = this.state.embedURLEdit.replace('{@CARDID}', card.value).replace('{@TOKEN}', x.token);
                    this.setState({
                        selectedCard: [x],
                        embedURL: url,
                        loading: true
                    });
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
            });
        }
        else {
            this.setState({
                selectedCard: [],
                embedURL: ''
            });
        }
    }

    hideSpinner() {
        this.setState({
            loading: false
        });
    }

    render() {
        const customValueRenderer = (selected, _options) => {
            return selected.length
                ? selected.map(({ label }) => label + ", ").join('').replace(/, $/, '')
                : "Saved cards & accounts...";
        };
        const { cards, selectedCard } = this.state;
        return (
            <div class="invoice_payment">
                <SiteMenu user={this.state.user} currentPage='invoicePayment' />
                <Form.Label style={{ padding: '15px 15px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 24 }}>
                    Manage Financial Account Wallet
                </Form.Label>

                <Row style={{ paddingLeft:'15px', paddingBottom:'5px'}}>
                    <Col xs='auto' sm='auto' md='auto'>
                        <Form.Label style={{ marginBotton: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 16, paddingTop:'5px' }}>
                            Select Payment Method to Edit:
                        </Form.Label>
                    </Col>
                    <Col md="auto" style={{ paddingLeft: '7px' }}>
                        <MultiSelect
                            style={{ width: '300px' }}
                            className="card multiselect sm"
                            options={cards}
                            onChange={this.selectCard}
                            disableSearch={true}
                            closeOnChangedValue={true}
                            labelledBy="Select"
                            value={selectedCard}
                            valueRenderer={customValueRenderer}
                            hasSelectAll={false}
                        />
                    </Col>
                    <Col xs='auto' sm='auto' md='auto'>
                        <Dropdown size='sm' onSelect={this.addNew}>
                            <Dropdown.Toggle size='sm' variant="success" style={{ backgroundColor: '#00973A', margin: '0px 0px 10px 0px', minHeight:'calc(1.5em + 0.5rem)'}}>
                                Add New Payment Method
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ justifyContent: 'end', minWidth: 'max-content', width: '100%' }}>
                                <Dropdown.Item eventKey='CreditCard'>Credit Card</Dropdown.Item>
                                <Dropdown.Item eventKey='ECheck'>ECheck / ACH</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Col>
                </Row>
                <Form.Label style={{ padding: '0px 0px 0px 15px', marginBotton: 0, verticalAlign: 'middle', fontStyle: 'italic', fontWeight:'400' }}>Need to remove a payment method from your account? Please email us at AR@boland.com</Form.Label>

                <div style={{ backgroundColor: '#f7f7f7', width: '850px', height: '600px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center' }}>

                    {this.state.loading ? (<Spinner
                        style={{ alignSelf: 'center' }}
                        animation="border"
                        role="status"
                        aria-hidden="true"
                    />
                    ) : null}
                    <iframe class="payment_iframe" hidden={this.state.loading} onLoad={this.hideSpinner} style={{ width: '850px', height: '100%' }} src={this.state.embedURL} key={this.state.forceRefreshVar} />
                </div>
            </div>
        );
    }
}

export default ManageWallet;